const setRequests=(context, payload) => {
  context.commit('SET_REQUESTS', payload)
}

const setOnlineAudiologists=(context, payload) => {
  context.commit('SET_ONLINE_AUDIOLOGISTS', payload)
}

export default {
  setRequests,
  setOnlineAudiologists
}
